<template>
  <div class="w-flex wrap smd-column" >
    <div class="grow " >
      <z-page class="white--bg mt3 sh2" :title="'Baka Insemination'" >
        <GChart :type="type_column" :data="baka_insemination_datas"   :options="column_options"  v-if="baka_insemination_datas.length > 0"/>
      </z-page>
    </div>
  </div>
  <div class="w-flex wrap smd-column" >
    <div class="grow " >
      <z-page class="white--bg mt3 sh2" :title="'Stock Vaksin'" >
        <GChart :type="type_column" :data="vaksin_datas"   :options="column_options"  v-if="vaksin_datas.length > 0"/>
      </z-page>
    </div>
  </div>
</template>

<script>
import { GChart } from "vue-google-charts";
export default {
  name: "Alman",
  components: {
        GChart
  },
  data() {
    return {
      loading: false,
      type_column: "ColumnChart", 
      column_options: {
          height: 500,
      },
      baka_insemination_datas: [],
      vaksin_datas: [],
    }
  },
  methods:{
    getBakaInsemination(){
      this.$zcomm.get(this.api_service + 'dashboard/alman_baka_insemination', {}).then(res => {
        this.baka_insemination_datas = res
      })
    },
    getVaksin(){
      this.$zcomm.get(this.api_service + 'dashboard/alman_vaksin', {}).then(res => {
        this.vaksin_datas = res
      })
    }
  },
      
  mounted() {
    this.getBakaInsemination()
    this.getVaksin()
  }
}
      

</script>  
